const expands = document.querySelectorAll('.filter__expand')

const handleExpanded = (button) => {
    if (!button) {
        return
    }

    const setState = (expanded) => {
        button.setAttribute('aria-expanded', expanded)
    }

    const getState = () => {
        return button.getAttribute('aria-expanded')
    }

    button.addEventListener('click', (e) => {
        e.preventDefault()
        setState(getState() === 'true' ? 'false' : 'true')
    })
}

const expandController = () => {
    expands?.forEach(button => {
        handleExpanded(button)
    })
}

const init = () => {
    expandController()
}

export default () => {
    init()
}